/* eslint-disable no-underscore-dangle */
import { call, put, select, takeLatest } from 'redux-saga/effects';
import SDK from 'utils/sdk';
import { transformIncomingLocationStationsToLocal } from 'utils/location-stations-transform';
import {
  getSelectedWorkoutLocation,
  getSelectedWorkoutRange,
} from './selector';

import { getWorkoutProgram } from './actions';

export function* getWorkoutProgramSagas() {
  try {
    yield put(getWorkoutProgram.request());
    const { startDate, endDate } = yield select(getSelectedWorkoutRange);
    const location = yield select(getSelectedWorkoutLocation);
    const client = yield call([SDK, 'getClient']);

    const { data } = yield call([client, 'locationStationDateRangeList'], {
      startDate: startDate.toISOString(),
      endDate: endDate.toISOString(),
      locationId: location?._id,
    });
    const parsedData = data.map((locationsStations) => {
      const tranformedStations = transformIncomingLocationStationsToLocal(
        [locationsStations.stations],
        null
      );
      return { ...locationsStations, stations: tranformedStations[0] };
    });
    yield put(getWorkoutProgram.success(parsedData));
  } catch (error) {
    const data = error?.response?.data?.message?.toString();
    yield put(getWorkoutProgram.failure(data));
  } finally {
    yield put(getWorkoutProgram.fulfill());
  }
}

export default function* workoutProgramWatch() {
  yield takeLatest(getWorkoutProgram, getWorkoutProgramSagas);
}
